import { useContext } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { IBusinessCollectionProps } from '../../../../../../Types/ObjektVy';
import {
  TEDLRBetalningSTATUSEnum,
  TEDLRLeverantorfakturaSTATUSEnum,
} from '../../../../../../globalQueryTypes';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { includes } from 'ramda';
import {
  OppnaBetalningMutation,
  OppnaBetalningMutationVariables,
} from './Mutations/_QueryTypes/OppnaBetalningMutation';
import BetalningQuery from './Queries/BetalningQuery.gql';
import OppnaBetalningMutationDoc from './Mutations/ÖppnaBetalningMutation.gql';
import {
  BetalningQuery as BetalningQueryData,
  BetalningQueryVariables,
} from './Queries/_QueryTypes/BetalningQuery';
import {
  definedSelectedId,
  selectedId,
} from '../../../../../../Components/MasterDetail/MasterDetailUtils';

const toBetalningsStatus = (
  fakturaStatus: TEDLRLeverantorfakturaSTATUSEnum
): TEDLRBetalningSTATUSEnum => {
  switch (fakturaStatus) {
    case TEDLRLeverantorfakturaSTATUSEnum.ANKOMSTREGISTRERAD:
      return TEDLRBetalningSTATUSEnum.ANKOMSTREGISTRERAD;
    case TEDLRLeverantorfakturaSTATUSEnum.DEFINITIVBOKAD:
      return TEDLRBetalningSTATUSEnum.DEFINITIVBOKAD;
    case TEDLRLeverantorfakturaSTATUSEnum.MAKULERAD:
      return TEDLRBetalningSTATUSEnum.MAKULERAD;
  }
};

interface IReturnValue {
  mutate: () => void;
  disabled: boolean;
}

export const useOppnaBetalning = (
  input: IBusinessCollectionProps
): IReturnValue => {
  const id = input.id;
  const activeDatabase = useContext(ActiveDatabaseContext).activeDatabase;

  const queryResult = useQuery<BetalningQueryData, BetalningQueryVariables>(
    BetalningQuery,
    {
      variables: { ID: selectedId(id) || '' },
      skip: !id,
    }
  );

  const node =
    queryResult?.data?.node?.__typename === 'TEDLRBetalning'
      ? queryResult?.data?.node
      : null;
  const version = node?._version;

  const mutationVariables: OppnaBetalningMutationVariables | undefined =
    node != null &&
    node.__typename === 'TEDLRBetalning' &&
    node._Associations?.Faktura != null &&
    id != null &&
    activeDatabase != null &&
    version != null
      ? {
          id: definedSelectedId(id),
          db: activeDatabase,
          version: version,
          status: toBetalningsStatus(node._Associations.Faktura.STATUS),
        }
      : undefined;

  const [öppnaBetalningMutationFn] = useMutation<
    OppnaBetalningMutation,
    OppnaBetalningMutationVariables
  >(OppnaBetalningMutationDoc, {
    variables: mutationVariables,
  });

  const disabled =
    mutationVariables == null ||
    !includes(node?.STATUS, [TEDLRBetalningSTATUSEnum.SPARRAD]);

  return { mutate: öppnaBetalningMutationFn, disabled };
};
